<ng-container *transloco="let t;">
@if(view === 'signingArea' && documentDetails$?.allow_chat === 1) {
    <form [formGroup]="chatForm" (ngSubmit)="onSubmit()" class="chat-app-form justify-content-between mt-50 mx-50 d-flex align-items-center">
        <div class=" w-100 me-50">
            <div class="input-group input-group-merge me-50 form-send-message">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <label for="attach-doc" class="attachment-icon mb-0">
                            <i data-feather="image" size="18" class="cursor-pointer lighten-2 text-secondary"></i>
                            <input type="file" #attachmentElement id="attach-doc" [accept]="acceptedImageTypes" hidden (change)="onFileChange($event)"/> 
                        </label>
                    </span>
                </div>
                <input formControlName="message" type="text" class="form-control message" [placeholder]='t("Message input placeholder (general) - Type your message")' name="chat-message" />
            </div>
        </div>
        <button [disabled]="chatForm.get('message')?.errors || sendMessageLoader" type="submit" class="btn btn-primary send" rippleEffect>
            <span *ngIf="!sendMessageLoader"><i data-feather="send" class="me-25 font-medium-2"></i></span>
            <span *ngIf="sendMessageLoader" class="spinner-border spinner-border-sm"></span>
        </button>
    </form>
} @else if(view === 'documentArea' || view === 'senderArea'){
    <form class="chat-app-form justify-content-between d-flex px-1" *ngIf="(canAccessChat$ | async)" [formGroup]="chatForm" (ngSubmit)="sendInternalMessage()">
        <div class=" w-100 me-50">
            <fieldset>
                <div class="input-group flex-nowrap">
                    <div ngbDropdown class="input-group-prepend" [ngClass]="{'internal-chat': form.scope.value === 'internal'}">
                        @if(form.scope.value === 'public'){
                        <button type="button" class="btn btn-outline-primary"
                            ngbDropdownToggle data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false" rippleEffect>
                            <i data-feather="edit-2"></i>
                        </button>
                        }
                        @else{
                        <button type="button" class="btn btn-outline-primary"
                            ngbDropdownToggle data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false" rippleEffect container="body" placement="top" [autoClose]="true" triggers="hover" [ngbTooltip]="t('Document internal chat tooltip text (Document internal chat) - Internal messages shows only for your internal users and not for recipients')">
                                <i data-feather="edit-2"></i>
                        </button>
                            }
                        <div ngbDropdownMenu>
                            <a ngbDropdownItem *ngFor="let scope of chatScopes" (click)="selectChatScope(scope.value)">{{ scope.name }}</a>
                        </div>
                    </div>
                    <!-- {{ form.scope.value === 'internal' ? 'yelow wali class' : '' }} -->
                    <input type="file" #attachmentElement id="attach-doc" [accept]="acceptedImageTypes" hidden (change)="onFileChange($event)"/> 
                    @if(form.scope.value === 'public'){
                        <div class=" position-relative w-100">
                            <label for="attach-doc" class="attachment-icon-for-document mb-0">
                                <i data-feather="image" size="18" class="cursor-pointer lighten-2 text-secondary"></i>
                            </label>
                            <input type="text" formControlName="message" class="form-control ps-3" [placeholder]='t("Message input placeholder (general) - Type your message")' />
                        </div>
                    }
                    @else {
                        <div class="relative-block-container">
                            <div class=" position-relative w-100">
                                <label for="attach-doc" class="attachment-icon-for-document mb-0">
                                    <i data-feather="image" size="18" class="cursor-pointer lighten-2 text-secondary"></i>
                                </label>
                                <textarea type="text" #textInputRef formControlName="message" rows="1" class="form-control ps-3 documentActivitieschat" [placeholder]='t("Message internal input placeholder (document activity chat) -  Type internal message")'> </textarea>
                                <ngx-mentions [textInputElement]="textInputRef"
                                    [menuTemplate]="menuTemplate"
                                    [mentionsConfig]="mentionsConfig"
                                    [searchRegexp]="searchRegexp"
                                    [mentions]="mentions"
                                    [removeWholeTagOnBackspace]="true"
                                    (search)="loadUsers($event)"
                                    (selectedChoicesChange)="onSelectedChoicesChange($event)">
                                </ngx-mentions>
                            
                                <ng-template #menuTemplate let-selectChoice="selectChoice">
                                    <ngx-text-input-autocomplete-menu [choices]="users"
                                                [getDisplayLabel]="getDisplayLabel"
                                                (selectChoice)="selectChoice($event)">
                                    </ngx-text-input-autocomplete-menu>
                                </ng-template>
                            </div>
                        </div>
                    }
                </div>
            </fieldset>
        </div>
        <button [disabled]="chatForm.get('message')?.errors || (sendInternalChatFormLoader$ | async)" type="submit" class="btn btn-primary send" rippleEffect>
            <span *ngIf="(sendInternalChatFormLoader$ | async) === false"><i data-feather="send" class="me-25 font-medium-2"></i></span>
            <span *ngIf="(sendInternalChatFormLoader$ | async)" class="spinner-border spinner-border-sm"></span>
        </button>
    </form>
}
</ng-container>
